export default {
  name: "al-index",

  components: {
    "al-view": () => import("./components/layout/View.vue")
  },
  data: () => ({}),

  computed: {},

  created: async function() {}
};

